import { PropsWithChildren, ReactNode } from "react";
import * as React from "react";
import clsx from "clsx";

export type BannerProps = {
  className?: string;
  children: ReactNode;
};

const Informative: React.FC<PropsWithChildren<BannerProps>> = ({ children, className }) => {
  return <Base className={clsx("border-border-action-info bg-platform-100", className)}>{children}</Base>;
};

const Base: React.FC<PropsWithChildren<BannerProps>> = ({ children, className, ...rest }) => {
  return (
    <div className={clsx("rounded-lg py-2 px-3 mt-2 border", className)} {...rest}>
      <h4 className="text-sm font-medium">{children}</h4>
    </div>
  );
};

export const Banner = {
  Informative,
  Base,
};

export default Banner;
